module.exports = __webpack_public_path__ + "static/media/4.a7e947b5.jpg";